var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5609 97.167H22.0833C19.7406 97.167 17.4938 96.2363 15.8372 94.5798C14.1807 92.9232 13.25 90.6764 13.25 88.3337V26.5003C13.25 24.1576 14.1807 21.9108 15.8372 20.2542C17.4938 18.5976 19.7406 17.667 22.0833 17.667H83.9167C86.2594 17.667 88.5062 18.5976 90.1628 20.2542C91.8193 21.9108 92.75 24.1576 92.75 26.5003V49.1357",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6667 8.8335V26.5002M13.25 44.1668H92.75M35.3333 8.8335V26.5002M64.5717 83.0335C63.6425 82.0647 62.9192 80.9178 62.4455 79.6618C61.9717 78.4058 61.7574 77.0669 61.8153 75.7258C61.8732 74.3847 62.2022 73.0693 62.7825 71.8589C63.3628 70.6484 64.1823 69.5681 65.1915 68.6831C66.2008 67.798 67.3788 67.1266 68.6547 66.7094C69.9305 66.2922 71.2777 66.1377 72.6149 66.2554C73.952 66.3731 75.2515 66.7605 76.4348 67.3942C77.6182 68.0279 78.6609 68.8948 79.5 69.9425C80.3432 68.9057 81.3868 68.0496 82.5684 67.4255C83.7501 66.8013 85.0455 66.4219 86.3771 66.3099C87.7088 66.1979 89.0494 66.3557 90.3187 66.7738C91.588 67.1918 92.7599 67.8616 93.7643 68.7431C94.7688 69.6245 95.5852 70.6995 96.1646 71.9037C96.744 73.1079 97.0746 74.4166 97.1366 75.7515C97.1986 77.0864 96.9907 78.4202 96.5254 79.6729C96.06 80.9256 95.3468 82.0716 94.4283 83.0423L82.8302 95.6563C82.4164 96.1328 81.9052 96.5148 81.331 96.7766C80.7569 97.0384 80.1332 97.1739 79.5022 97.1739C78.8712 97.1739 78.2475 97.0384 77.6734 96.7766C77.0992 96.5148 76.588 96.1328 76.1742 95.6563L64.5717 83.0335Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarHeart);
export default __webpack_public_path__ + "static/media/calendarHeart.18b76637e7775e5a50315b3b57369199.svg";
export { ForwardRef as ReactComponent };